module.exports = __webpack_public_path__ + "media/bookPage/2-620dbbeb.jpeg";